import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { manageSaveSearchFilterSliceInitialState } from "./initialState";

const manageSaveSearchFilterSlice = createSlice({
  name: "manageSaveSearchFilters",
  initialState: () => {
    const initialState = { ...manageSaveSearchFilterSliceInitialState };
    return initialState;
  },
  reducers: {
    setMssFolderName(state, action: PayloadAction<string>) {
      state.folderName = action.payload;
      return state;
    },
    setMssActiveTab(state, action: PayloadAction<string>) {
      state.activeTab = action.payload;
      return state;
    },
    setMssPageNumber(state, action: PayloadAction<number>) {
      state.pageNumber = action.payload;
      return state;
    },
    setMssActiveTabFolderCount(state, action: PayloadAction<number>) {
      state.activeTabFolderCount = action.payload;
      return state;
    },
  },
});

export const { setMssActiveTab, setMssFolderName, setMssPageNumber,setMssActiveTabFolderCount } =
  manageSaveSearchFilterSlice.actions;

export default manageSaveSearchFilterSlice;
